import React, { ReactElement } from 'react';
import {
  Button, Td, Th, Tr,
} from 'idsk-react-components';
import LegislativnyMaterialCreateUpdate
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import LegMaterialCreateStepEnum
  from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import './checkDataTable.scss';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
}

const FilledTableBasicData2 = ({
  legislativnyMaterial,
  onChangeStep,
}: Props): ReactElement => {
  const getOptionalMessagePravnaOblast = (): ReactElement => {
    const isOptional = legislativnyMaterial.typ.kod === 'NelegislativnyVseobecnyMaterial'
      || legislativnyMaterial.typ.kod === 'PersonalnyNavrhNaRokovanieVlady';
    return isOptional && (
      <span className="idsk-hint">(nepovinný údaj)</span>
    );
  };

  return (
    <>
      <Tr>
        <Th>Názov</Th>
        <Td>{legislativnyMaterial.nazov}</Td>
        <Td>
          <Button
            size="small"
            buttonStyle="link"
            onClick={() => {
              onChangeStep(LegMaterialCreateStepEnum.BASIC_DATA_2);
            }}
          >
            Zmeniť
          </Button>
        </Td>
      </Tr>
      {(legislativnyMaterial.typ?.kod !== 'AktEU') && (
        <>
          <Tr>
            <Th>Právna oblasť {getOptionalMessagePravnaOblast()}</Th>
            <Td>
              {legislativnyMaterial?.oblastList?.length === 1
                ? legislativnyMaterial?.oblastList[0].nazov : (
                  <ul>
                    {legislativnyMaterial.oblastList
                      ?.sort((a, b) => Intl.Collator().compare(a.nazov, b.nazov))
                      .map(oblast => (
                        <li key={oblast.uuid}>{oblast.nazov}</li>
                      ))}
                  </ul>
                )}
            </Td>
            <Td>
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.BASIC_DATA_2);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
          <Tr>
            <Th>Rezortné číslo</Th>
            <Td>{legislativnyMaterial.rezortneCislo}</Td>
            <Td>
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.BASIC_DATA_2);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
          <Tr>
            <Th>Podnet</Th>
            <Td>{legislativnyMaterial.podnet}</Td>
            <Td>
              <Button
                size="small"
                buttonStyle="link"
                onClick={() => {
                  onChangeStep(LegMaterialCreateStepEnum.BASIC_DATA_2);
                }}
              >
                Zmeniť
              </Button>
            </Td>
          </Tr>
        </>
      )}
    </>
  );
};
export default FilledTableBasicData2;
